module.exports = __webpack_public_path__ + "img/36_32.6275fc46.png";